import _get from "lodash/get"
import { NumericFormat } from "react-number-format"

import Button from "@/components/core/Button/Button"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import PDPRequiredItemModal from "@/components/ProductDetail/v3/PDPRequiredItemModal"
import { getEventInfo } from "@/components/ProductDetail/v3/analytics"

const InstallReqItems = props => {
  const {
    isDiscontinued = false,
    staticTexts = {},
    price = 0,
    discountedPrice = 0,
    currencySign = "",
    installReq = [],
    productAnalyticsData = {},
    onInstallCTA = () => {},
    toolTipIcon = "",
    handleInfoToolTipHover = () => {},
    setShowTooltip = () => {},
    showTooltip = false,
    isMobileOnly = false,
    handleRemove = () => {},
    priceList = [],
    subTotal = 0,
    requiredItems = [],
    getRequireItems = () => {},
    installReqData = [],
    reqItemLwData = [],
    onModalClose = () => {},
    showPDPInstallModal = false,
    config = {},
    currencyCode = "",
  } = props

  const { internationalization: { locale = "" } = {} } = config
  const { itemReqCTA = "", editItemReqCTA = "" } = staticTexts

  return (
    <>
      {!isDiscontinued && requiredItems?.length > 0 && (
        <>
          <div className="row no-gutters product-detail-page__install-item">
            <div className="product-detail-page__install-item-btn">
              <Button
                role="button"
                className="gbh-data-layer"
                data-gbh-data-layer={getEventInfo(
                  (installReq.length === 0
                    ? itemReqCTA
                    : editItemReqCTA
                  ).toLowerCase()
                )}
                data-gbh-data-layer-custom={
                  productAnalyticsData.stringProductInfo
                }
                label={
                  installReq.length === 0
                    ? staticTexts?.itemReqCTA
                    : staticTexts?.editItemReqCTA
                }
                size="small"
                type="ghost"
                onClick={onInstallCTA}
              />
              <div className="product-detail-page__tooltip-icon">
                <img
                  src={toolTipIcon.src}
                  alt={staticTexts?.toolTip}
                  onMouseOver={e => handleInfoToolTipHover(e)}
                  onMouseLeave={() => setShowTooltip(false)}
                  width={"16px"}
                  height={"16px"}
                  data-testid="img-tooltip-installRqitm"
                />
                {showTooltip && <ToolTip message={staticTexts?.tooltipMsg} />}
              </div>
            </div>
          </div>
          {installReq.length > 0 && (
            <div className="no-gutters product-detail-page__install-items-container">
              <div className="product-detail-page__required-product-header">
                <div>{staticTexts?.requiredItemsProduct}</div>
                <div>{staticTexts?.requiredItemsPrice}</div>
              </div>
              {installReq &&
                installReq.map((item, i) => (
                  <div
                    key={i}
                    className="col-12 product-detail-page__install-item-details"
                  >
                    <div className="row">
                      {!isMobileOnly ? (
                        <div className="col-2">
                          <div>
                            <img
                              alt=""
                              src={_get(
                                item.imagesData.find(
                                  list => list.id === item.skuid
                                ),
                                "image",
                                ""
                              )}
                              width={"80px"}
                              height={"80px"}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className={isMobileOnly ? "col-8" : "col-6"}>
                        <span className="item-details">{item.productName}</span>
                        <div className="item-description">
                          {item.productDescription}
                        </div>
                        {!_get(
                          item.colorsData.find(list => list.id === item.skuid),
                          "notApplicable",
                          false
                        ) && (
                          <div>
                            <span className="item-color-details">
                              {staticTexts?.colorOrFinish} :{" "}
                              {_get(
                                item.colorsData.find(
                                  list => list.id === item.skuid
                                ),
                                "label",
                                ""
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="col-4">
                        <h4 className="item-price">
                          <NumericFormat
                            value={
                              _get(
                                item.priceData.find(
                                  list => list.id === item.skuid
                                ),
                                "discountedPrice",
                                0
                              ) > 0
                                ? _get(
                                    item.priceData.find(
                                      list => list.id === item.skuid
                                    ),
                                    "discountedPrice",
                                    0
                                  )
                                : _get(
                                    item.priceData.find(
                                      list => list.id === item.skuid
                                    ),
                                    "price",
                                    0
                                  )
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={currencySign}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </h4>
                        {_get(
                          item.priceData.find(list => list.id === item.skuid),
                          "discountedPrice",
                          0
                        ) > 0 && (
                          <>
                            <div className="discount-price-item">
                              <div className="discount-price">
                                <NumericFormat
                                  value={_get(
                                    item.priceData.find(
                                      list => list.id === item.skuid
                                    ),
                                    "price",
                                    0
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySign}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                              </div>
                              <div className="discount-percent">
                                {_get(
                                  item.priceData.find(
                                    list => list.id === item.skuid
                                  ),
                                  "discountType",
                                  ""
                                ) === "absolute" ? (
                                  <NumericFormat
                                    value={_get(
                                      item.priceData.find(
                                        list => list.id === item.skuid
                                      ),
                                      "discountPercent",
                                      0
                                    )}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={currencySign}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                ) : (
                                  _get(
                                    item.priceData.find(
                                      list => list.id === item.skuid
                                    ),
                                    "discountPercent",
                                    0
                                  ) + "%"
                                )}{" "}
                                {staticTexts?.percentOff}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="remove">
                          <a
                            className="remove-link gbh-data-layer"
                            onClick={() => handleRemove(item)}
                            data-gbh-data-layer={getEventInfo(
                              staticTexts?.remove?.toLowerCase()
                            )}
                            data-gbh-data-layer-custom={
                              productAnalyticsData.stringProductInfo
                            }
                          >
                            {staticTexts?.remove}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              <div className="col-12 product-detail-page__install-item-details">
                <div className="row">
                  <div className="col-8">
                    <div className="base-product">
                      {staticTexts?.baseProduct}
                    </div>
                    <div className="base-product">
                      {staticTexts?.requiredItems}
                    </div>
                    <div className="total">{staticTexts?.subTotal}</div>
                  </div>
                  <div className="col-4">
                    <div className="item-price">
                      <NumericFormat
                        value={discountedPrice > 0 ? discountedPrice : price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </div>
                    <div>
                      <h4 className="item-price">
                        <NumericFormat
                          value={priceList}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={currencySign}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </h4>
                    </div>
                    <div className="sub-total">
                      <NumericFormat
                        value={subTotal.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <PDPRequiredItemModal
            {...props}
            staticTexts={staticTexts}
            getRequireItemsData={addItems => getRequireItems(addItems)}
            installRequiredItemsData={installReqData}
            reqItemLwData={reqItemLwData}
            onModalClose={onModalClose}
            showModal={showPDPInstallModal}
            locale={locale}
            currencyCode={currencyCode}
            installReq={installReq}
            currencySign={currencySign}
            productInfo={productAnalyticsData.stringProductInfo}
          />
        </>
      )}
    </>
  )
}

export default InstallReqItems
